import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Masonry from '@mui/lab/Masonry';
import { styled } from '@mui/material/styles';
import { ProductImage } from '../gadgets';
const Label = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}));

 const Product=()=> {
     return (
     <>
             <div className="productheader">
                 <h1>
                     
           our art gallery  
                 </h1>
      </div>
    <Box sx={{ width: 350, minHeight: 829,marginTop:3 }}>
      <Masonry columns={{ xs: 2, sm: 3 }}  spacing={2}>
        {ProductImage.map((item, index) => (
          <div key={index}>
            <Label>{index + 1}</Label>
            <img
              src={item.image}
              srcSet={item.image}
              alt={item.title}
              loading="lazy"
              style={{
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
                display: 'block',
                width: '100%',
              }}
            />
          </div>
        ))}
      </Masonry>
    </Box>
     </>
  );
}
export default Product;
